import { JSX, useEffect, useState } from 'react';
import { getMyInterviewAPIKey } from '../../../../utilities/envVariables';
import { AspectRatio } from '@chakra-ui/react';
import { useTranslation } from "react-i18next";

interface IProps {
  hashTimestamp?: number;
  hash?: string;
  videoId?: string;
}
export default function InterviewVideoPlayer({ hashTimestamp, hash = '', videoId }: IProps): JSX.Element | null {
    const { t } = useTranslation('common');
  const [apiKey, setApiKey] = useState<string | undefined>(undefined);

  useEffect(() => {
    (async () => {
      const myInterviewApiKey = await getMyInterviewAPIKey();
      const [_, key] = myInterviewApiKey.split(' ');
      setApiKey(key);
    })();
  }, []);

  if (!hashTimestamp || !videoId || !apiKey) return null;

  const params = new URLSearchParams();
  params.append('hashTimestamp', String(hashTimestamp));
  params.append('hash', hash);
  params.append('video', videoId);
  params.append('autoplay', '0');
  params.append('fs', '1');
  params.append('apiKey', apiKey);

  return (
    <AspectRatio maxH="400px" bgColor="blackAlpha.500" mb="6">
      <iframe
        title={t('common:interview')}
        width={'100%'}
        height={'100%'}
        src={`https://share.myinterview.com/player?${params.toString()}`}
        allowFullScreen
      />
    </AspectRatio>
  );
}
